import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface DeleteColumnDialogProps {
  feederCode: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteColumnDialog({
  feederCode,
  onCancel,
  onConfirm,
}: DeleteColumnDialogProps): React.JSX.Element {
  return (
    <Dialog open={Boolean(feederCode)} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Delete feeder column?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          This removes all base and buffer prices for feeder origin <strong>{feederCode}</strong> from the draft.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Delete column
        </Button>
      </DialogActions>
    </Dialog>
  );
}
